<div class="demo-report-modal">
    <!-- Modal Header -->
    <div class="modal-header">
        <div class="header-left">
            <div class="header-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" stroke="#d3a700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3 9H21" stroke="#d3a700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 21V9" stroke="#d3a700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="header-text">
                <h2>Daily Insights Report</h2>
                <span class="header-subtitle">Example · Not your company data</span>
            </div>
        </div>
        <button class="close-button" (click)="closeModal()" aria-label="Close modal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
        <iframe 
            src="./assets/docs/SuperSee_Daily_Insights_for_2026-09-01_SuperSee.html" 
            frameborder="0" 
            title="Daily Report Demo" 
            class="demo-iframe">
        </iframe>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
        <div class="footer-info">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#6b7280" stroke-width="2"/>
                <path d="M12 16V12" stroke="#6b7280" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="8" r="1" fill="#6b7280"/>
            </svg>
            <span>Example report · Not your company data. Configure recipients to receive Daily Insights.</span>
        </div>
        <button class="close-btn" (click)="closeModal()">Close</button>
    </div>
</div>
